import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { AuthService, ProfileAvatarComponent, UserQuery } from '@examdojo/user';
import { TranslocoPipe } from '@jsverse/transloco';
import { filter, map, startWith } from 'rxjs';
import { RootUrlParts } from '../app.model';
import { HelpSidenavService } from '../services/help-sidenav.service';

@Component({
  selector: 'dojo-authenticated-layout',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    ButtonComponent,
    IconComponent,
    IconButtonComponent,
    ProfileAvatarComponent,
    TranslocoPipe,
  ],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatedLayoutComponent {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly helpSidenavService: HelpSidenavService,
  ) {}

  readonly showHelpSidenav = this.helpSidenavService.showHelpSidenav;

  readonly state = connectState({
    user: this.userQuery.active$,
    isLoading: this.userQuery.selectLoading(),
    showSidenav: this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => event.url),
      startWith(this.router.url),
      map((url) => !url.includes(`/${RootUrlParts.Syllabus}/`)),
    ),
  });

  toggleHelpSidenav() {
    this.helpSidenavService.toggle();
  }

  closeHelpSidenav() {
    this.helpSidenavService.close();
  }

  onHelpSidenavOpenedChange(isOpen: boolean) {
    // Sync the service state with the actual sidenav state
    if (isOpen !== this.showHelpSidenav()) {
      if (isOpen) {
        this.helpSidenavService.open();
      } else {
        this.helpSidenavService.close();
      }
    }
  }

  async signOut() {
    await this.authService.signOut();
  }
}
